const request = require('superagent');

const {
  DEV,
  QA,
  STAGING,
  OCULTO,
  PRODUCCION,
  MOCK,
  CMS_DEV,
  LOCAL,
  DEV_HOST,
  QA_HOST,
  STAGING_HOST,
  OCULTO_HOST,
  PRODUCCION_HOST,
  MOCK_HOST,
  CMS_DEV_HOST,
  API_URL_POST,
} = require('constants/index');

const get = (url, queryParams = {}, headers = {}) => new Promise(
  (resolve, reject) => request
    .get(url)
    .query(queryParams)
    .set(headers)
    .then(res => resolve(res))
    .catch(err => reject(err)),
);

const post = (url, body = {}, queryParams = {}, headers = {}) => new Promise(
  (resolve, reject) => request
    .post(url)
    .query(queryParams)
    .set(headers)
    .send(body)
    .then(res => resolve(res))
    .catch(err => reject(err)),
);

const getURLAPI = (host, url) => {
  let urlAPI = '';
  switch (host) {
    case DEV_HOST:
      urlAPI = `${DEV}${url}`;
      break;
    case QA_HOST:
      urlAPI = `${QA}${url}`;
      break;
    case STAGING_HOST:
      urlAPI = `${STAGING}${url}`;
      break;
    case OCULTO_HOST:
      urlAPI = `${OCULTO}${url}`;
      break;
    case PRODUCCION_HOST:
      urlAPI = `${PRODUCCION}${url}`;
      break;
    case MOCK_HOST:
      urlAPI = `${MOCK}${url}`;
      break;
    case CMS_DEV_HOST:
      urlAPI = `${CMS_DEV}${url}`;
      break;
    default:
      urlAPI = `${LOCAL}${url}`;
  }

  return urlAPI;
};

const APIGet = (configuration) => {
  return get(
    getURLAPI(configuration.environmentConfig, configuration.apiUrl),
    null,
    configuration.configHeader,
  );
};

const APIPost = (configuration, postValues = null) => {
  return post(
    getURLAPI(configuration.environmentConfig, API_URL_POST),
    postValues,
    null,
    configuration.configHeader,
  );
};

module.exports = {
  APIGet,
  APIPost,
};
